export enum SessionStorageValues {
    SavedUserData = 'savedUserData',
    RouteBeforeRefresh = 'routeBeforeRefresh'
}